module.exports = __webpack_public_path__ + "static/media/pullman04.6b19403e.jpg";